import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { useSetMeasureValues } from '@grow-therapy-team/seedling-components';

import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { drawerStateAtom, isEditingFormOrMeasureAtom, selectedClientUserShortIdAtom } from '../state';

export function useClearMeasureCallback() {
  const setSelectedClientUserShortId = useSetAtom(selectedClientUserShortIdAtom);
  const setMeasureValues = useSetMeasureValues();
  const setDrawerState = useSetAtom(drawerStateAtom);
  const getIsEditingFormOrMeasure = useAtomCallbackMemoized((get) => get(isEditingFormOrMeasureAtom), []);

  return useCallback(() => {
    setSelectedClientUserShortId(undefined);
    setMeasureValues({});
    if (getIsEditingFormOrMeasure()) {
      setDrawerState(null);
    }
  }, [getIsEditingFormOrMeasure, setSelectedClientUserShortId, setMeasureValues, setDrawerState]);
}
